export const FINISHED_SKU_LUT_URL =
    'https://www.kendrascott.com/on/demandware.static/-/Library-Sites-SiteGenesisSharedLibrary/default/fluid/finished_sku_lut.csv'

export const NAME_EXP = /[^\x20-\x7E]+/g
